/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  SelectField,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { RiskOpportunity } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function RiskOpportunityFutureFinancialEffectUpdateForm(props) {
  const {
    id: idProp,
    riskOpportunity: riskOpportunityModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    FinancialPositionChangeType: "",
    FutureFinancialEffectTimeHorizon: "",
    FinancialPositionValue: "",
    FinancialPositionUnit: "",
    FinancialPositionValueMin: "",
    FinancialPositionValueMax: "",
    FinancialPositionQualitativeDescription: "",
    WhyNoQuanitativeFinancialData: "",
    FinancialPositionQuantitativeDescription: "",
  };
  const [FinancialPositionChangeType, setFinancialPositionChangeType] =
    React.useState(initialValues.FinancialPositionChangeType);
  const [
    FutureFinancialEffectTimeHorizon,
    setFutureFinancialEffectTimeHorizon,
  ] = React.useState(initialValues.FutureFinancialEffectTimeHorizon);
  const [FinancialPositionValue, setFinancialPositionValue] = React.useState(
    initialValues.FinancialPositionValue
  );
  const [FinancialPositionUnit, setFinancialPositionUnit] = React.useState(
    initialValues.FinancialPositionUnit
  );
  const [FinancialPositionValueMin, setFinancialPositionValueMin] =
    React.useState(initialValues.FinancialPositionValueMin);
  const [FinancialPositionValueMax, setFinancialPositionValueMax] =
    React.useState(initialValues.FinancialPositionValueMax);
  const [
    FinancialPositionQualitativeDescription,
    setFinancialPositionQualitativeDescription,
  ] = React.useState(initialValues.FinancialPositionQualitativeDescription);
  const [WhyNoQuanitativeFinancialData, setWhyNoQuanitativeFinancialData] =
    React.useState(initialValues.WhyNoQuanitativeFinancialData);
  const [
    FinancialPositionQuantitativeDescription,
    setFinancialPositionQuantitativeDescription,
  ] = React.useState(initialValues.FinancialPositionQuantitativeDescription);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = riskOpportunityRecord
      ? { ...initialValues, ...riskOpportunityRecord }
      : initialValues;
    setFinancialPositionChangeType(cleanValues.FinancialPositionChangeType);
    setFutureFinancialEffectTimeHorizon(
      cleanValues.FutureFinancialEffectTimeHorizon
    );
    setFinancialPositionValue(cleanValues.FinancialPositionValue);
    setFinancialPositionUnit(cleanValues.FinancialPositionUnit);
    setFinancialPositionValueMin(cleanValues.FinancialPositionValueMin);
    setFinancialPositionValueMax(cleanValues.FinancialPositionValueMax);
    setFinancialPositionQualitativeDescription(
      cleanValues.FinancialPositionQualitativeDescription
    );
    setWhyNoQuanitativeFinancialData(cleanValues.WhyNoQuanitativeFinancialData);
    setFinancialPositionQuantitativeDescription(
      cleanValues.FinancialPositionQuantitativeDescription
    );
    setErrors({});
  };
  const [riskOpportunityRecord, setRiskOpportunityRecord] = React.useState(
    riskOpportunityModelProp
  );
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(RiskOpportunity, idProp)
        : riskOpportunityModelProp;
      setRiskOpportunityRecord(record);
    };
    queryData();
  }, [idProp, riskOpportunityModelProp]);
  React.useEffect(resetStateValues, [riskOpportunityRecord]);
  const validations = {
    FinancialPositionChangeType: [],
    FutureFinancialEffectTimeHorizon: [],
    FinancialPositionValue: [],
    FinancialPositionUnit: [],
    FinancialPositionValueMin: [],
    FinancialPositionValueMax: [],
    FinancialPositionQualitativeDescription: [],
    WhyNoQuanitativeFinancialData: [],
    FinancialPositionQuantitativeDescription: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          FinancialPositionChangeType,
          FutureFinancialEffectTimeHorizon,
          FinancialPositionValue,
          FinancialPositionUnit,
          FinancialPositionValueMin,
          FinancialPositionValueMax,
          FinancialPositionQualitativeDescription,
          WhyNoQuanitativeFinancialData,
          FinancialPositionQuantitativeDescription,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          const modelFieldsToSave = {};
          await DataStore.save(
            RiskOpportunity.copyOf(riskOpportunityRecord, (updated) => {
              Object.assign(updated, modelFieldsToSave);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(
        overrides,
        "RiskOpportunityFutureFinancialEffectUpdateForm"
      )}
      {...rest}
    >
      <Heading
        level={4}
        children="Anticipated Effects on Financial Position, Financial Performance and Cash Flows"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="IFRS S2 paragraph 16 c-d, 17, 19-21."
        {...getOverrideProps(overrides, "SectionalElement00")}
      ></Heading>
      <Text
        children="Update data about how you expect your financial position to change over the short, medium and long term, given your strategy to manage climate-related risks and opportunities."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <Heading
        children="IFRS S2 paragraph 16 c-d, 17."
        {...getOverrideProps(overrides, "SectionalElement000")}
      ></Heading>
      <Text
        children="Update quantitative information about the anticipated future financial effects of your climate-related risk / opportunity. You can enter a single aggregated amount, or a range."
        {...getOverrideProps(overrides, "SectionalElement5")}
      ></Text>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid6")}
      >
        <SelectField
          label="Type of future financial position"
          placeholder="Please select the type of future financial position"
          value={FinancialPositionChangeType}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                FinancialPositionChangeType: value,
                FutureFinancialEffectTimeHorizon,
                FinancialPositionValue,
                FinancialPositionUnit,
                FinancialPositionValueMin,
                FinancialPositionValueMax,
                FinancialPositionQualitativeDescription,
                WhyNoQuanitativeFinancialData,
                FinancialPositionQuantitativeDescription,
              };
              const result = onChange(modelFields);
              value = result?.FinancialPositionChangeType ?? value;
            }
            if (errors.FinancialPositionChangeType?.hasError) {
              runValidationTasks("FinancialPositionChangeType", value);
            }
            setFinancialPositionChangeType(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "FinancialPositionChangeType",
              FinancialPositionChangeType
            )
          }
          errorMessage={errors.FinancialPositionChangeType?.errorMessage}
          hasError={errors.FinancialPositionChangeType?.hasError}
          {...getOverrideProps(overrides, "FinancialPositionChangeType")}
        ></SelectField>
        <SelectField
          label="Time horizon of future financial effect"
          placeholder="Please select the time horizon the future financial effect should occur within"
          value={FutureFinancialEffectTimeHorizon}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                FinancialPositionChangeType,
                FutureFinancialEffectTimeHorizon: value,
                FinancialPositionValue,
                FinancialPositionUnit,
                FinancialPositionValueMin,
                FinancialPositionValueMax,
                FinancialPositionQualitativeDescription,
                WhyNoQuanitativeFinancialData,
                FinancialPositionQuantitativeDescription,
              };
              const result = onChange(modelFields);
              value = result?.FutureFinancialEffectTimeHorizon ?? value;
            }
            if (errors.FutureFinancialEffectTimeHorizon?.hasError) {
              runValidationTasks("FutureFinancialEffectTimeHorizon", value);
            }
            setFutureFinancialEffectTimeHorizon(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "FutureFinancialEffectTimeHorizon",
              FutureFinancialEffectTimeHorizon
            )
          }
          errorMessage={errors.FutureFinancialEffectTimeHorizon?.errorMessage}
          hasError={errors.FutureFinancialEffectTimeHorizon?.hasError}
          {...getOverrideProps(overrides, "FutureFinancialEffectTimeHorizon")}
        ></SelectField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid7")}
      >
        <TextField
          label="Amount of anticipated financial position"
          type="number"
          step="any"
          value={FinancialPositionValue}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                FinancialPositionChangeType,
                FutureFinancialEffectTimeHorizon,
                FinancialPositionValue: value,
                FinancialPositionUnit,
                FinancialPositionValueMin,
                FinancialPositionValueMax,
                FinancialPositionQualitativeDescription,
                WhyNoQuanitativeFinancialData,
                FinancialPositionQuantitativeDescription,
              };
              const result = onChange(modelFields);
              value = result?.FinancialPositionValue ?? value;
            }
            if (errors.FinancialPositionValue?.hasError) {
              runValidationTasks("FinancialPositionValue", value);
            }
            setFinancialPositionValue(value);
          }}
          onBlur={() =>
            runValidationTasks("FinancialPositionValue", FinancialPositionValue)
          }
          errorMessage={errors.FinancialPositionValue?.errorMessage}
          hasError={errors.FinancialPositionValue?.hasError}
          {...getOverrideProps(overrides, "FinancialPositionValue")}
        ></TextField>
        <TextField
          label="Unit of measure of anticipated financial position"
          value={FinancialPositionUnit}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                FinancialPositionChangeType,
                FutureFinancialEffectTimeHorizon,
                FinancialPositionValue,
                FinancialPositionUnit: value,
                FinancialPositionValueMin,
                FinancialPositionValueMax,
                FinancialPositionQualitativeDescription,
                WhyNoQuanitativeFinancialData,
                FinancialPositionQuantitativeDescription,
              };
              const result = onChange(modelFields);
              value = result?.FinancialPositionUnit ?? value;
            }
            if (errors.FinancialPositionUnit?.hasError) {
              runValidationTasks("FinancialPositionUnit", value);
            }
            setFinancialPositionUnit(value);
          }}
          onBlur={() =>
            runValidationTasks("FinancialPositionUnit", FinancialPositionUnit)
          }
          errorMessage={errors.FinancialPositionUnit?.errorMessage}
          hasError={errors.FinancialPositionUnit?.hasError}
          {...getOverrideProps(overrides, "FinancialPositionUnit")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid8")}
      >
        <TextField
          label="Minimum amount of anticipated financial position"
          type="number"
          step="any"
          value={FinancialPositionValueMin}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                FinancialPositionChangeType,
                FutureFinancialEffectTimeHorizon,
                FinancialPositionValue,
                FinancialPositionUnit,
                FinancialPositionValueMin: value,
                FinancialPositionValueMax,
                FinancialPositionQualitativeDescription,
                WhyNoQuanitativeFinancialData,
                FinancialPositionQuantitativeDescription,
              };
              const result = onChange(modelFields);
              value = result?.FinancialPositionValueMin ?? value;
            }
            if (errors.FinancialPositionValueMin?.hasError) {
              runValidationTasks("FinancialPositionValueMin", value);
            }
            setFinancialPositionValueMin(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "FinancialPositionValueMin",
              FinancialPositionValueMin
            )
          }
          errorMessage={errors.FinancialPositionValueMin?.errorMessage}
          hasError={errors.FinancialPositionValueMin?.hasError}
          {...getOverrideProps(overrides, "FinancialPositionValueMin")}
        ></TextField>
        <TextField
          label="Maximum amount of anticipated financial position"
          type="number"
          step="any"
          value={FinancialPositionValueMax}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                FinancialPositionChangeType,
                FutureFinancialEffectTimeHorizon,
                FinancialPositionValue,
                FinancialPositionUnit,
                FinancialPositionValueMin,
                FinancialPositionValueMax: value,
                FinancialPositionQualitativeDescription,
                WhyNoQuanitativeFinancialData,
                FinancialPositionQuantitativeDescription,
              };
              const result = onChange(modelFields);
              value = result?.FinancialPositionValueMax ?? value;
            }
            if (errors.FinancialPositionValueMax?.hasError) {
              runValidationTasks("FinancialPositionValueMax", value);
            }
            setFinancialPositionValueMax(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "FinancialPositionValueMax",
              FinancialPositionValueMax
            )
          }
          errorMessage={errors.FinancialPositionValueMax?.errorMessage}
          hasError={errors.FinancialPositionValueMax?.hasError}
          {...getOverrideProps(overrides, "FinancialPositionValueMax")}
        ></TextField>
      </Grid>
      <TextAreaField
        label="Description of anticipated financial position"
        value={FinancialPositionQualitativeDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              FinancialPositionChangeType,
              FutureFinancialEffectTimeHorizon,
              FinancialPositionValue,
              FinancialPositionUnit,
              FinancialPositionValueMin,
              FinancialPositionValueMax,
              FinancialPositionQualitativeDescription: value,
              WhyNoQuanitativeFinancialData,
              FinancialPositionQuantitativeDescription,
            };
            const result = onChange(modelFields);
            value = result?.FinancialPositionQualitativeDescription ?? value;
          }
          if (errors.FinancialPositionQualitativeDescription?.hasError) {
            runValidationTasks(
              "FinancialPositionQualitativeDescription",
              value
            );
          }
          setFinancialPositionQualitativeDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "FinancialPositionQualitativeDescription",
            FinancialPositionQualitativeDescription
          )
        }
        errorMessage={
          errors.FinancialPositionQualitativeDescription?.errorMessage
        }
        hasError={errors.FinancialPositionQualitativeDescription?.hasError}
        {...getOverrideProps(
          overrides,
          "FinancialPositionQualitativeDescription"
        )}
      ></TextAreaField>
      <Heading
        children="IFRS S2 paragraph 19-21."
        {...getOverrideProps(overrides, "SectionalElement0000")}
      ></Heading>
      <Text
        children="If you cannot provide quantitative information about the anticipated financial effects of your climate-related risk or opportunity, explain why and include a description of relevant qualitative information. If you cannot provide qualitative information about this risk or opportunity, enter aggregated financial effect data separately."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Text>
      <TextAreaField
        label="Describe why you cannot provide data on the anticipated quantitative financial effects arising from this climate-related risk / opportunity"
        value={WhyNoQuanitativeFinancialData}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              FinancialPositionChangeType,
              FutureFinancialEffectTimeHorizon,
              FinancialPositionValue,
              FinancialPositionUnit,
              FinancialPositionValueMin,
              FinancialPositionValueMax,
              FinancialPositionQualitativeDescription,
              WhyNoQuanitativeFinancialData: value,
              FinancialPositionQuantitativeDescription,
            };
            const result = onChange(modelFields);
            value = result?.WhyNoQuanitativeFinancialData ?? value;
          }
          if (errors.WhyNoQuanitativeFinancialData?.hasError) {
            runValidationTasks("WhyNoQuanitativeFinancialData", value);
          }
          setWhyNoQuanitativeFinancialData(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "WhyNoQuanitativeFinancialData",
            WhyNoQuanitativeFinancialData
          )
        }
        errorMessage={errors.WhyNoQuanitativeFinancialData?.errorMessage}
        hasError={errors.WhyNoQuanitativeFinancialData?.hasError}
        {...getOverrideProps(overrides, "WhyNoQuanitativeFinancialData")}
      ></TextAreaField>
      <TextAreaField
        label="Provide a qualitative description of the anticipated financial effect of this climate-related risk / opportunity"
        value={FinancialPositionQuantitativeDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              FinancialPositionChangeType,
              FutureFinancialEffectTimeHorizon,
              FinancialPositionValue,
              FinancialPositionUnit,
              FinancialPositionValueMin,
              FinancialPositionValueMax,
              FinancialPositionQualitativeDescription,
              WhyNoQuanitativeFinancialData,
              FinancialPositionQuantitativeDescription: value,
            };
            const result = onChange(modelFields);
            value = result?.FinancialPositionQuantitativeDescription ?? value;
          }
          if (errors.FinancialPositionQuantitativeDescription?.hasError) {
            runValidationTasks(
              "FinancialPositionQuantitativeDescription",
              value
            );
          }
          setFinancialPositionQuantitativeDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "FinancialPositionQuantitativeDescription",
            FinancialPositionQuantitativeDescription
          )
        }
        errorMessage={
          errors.FinancialPositionQuantitativeDescription?.errorMessage
        }
        hasError={errors.FinancialPositionQuantitativeDescription?.hasError}
        {...getOverrideProps(
          overrides,
          "FinancialPositionQuantitativeDescription"
        )}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || riskOpportunityModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || riskOpportunityModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
